import { useSessionStorage } from "@mantine/hooks";
import {
  BASE_HEADER_HEIGHT,
  CLUSTER_ROW_HEIGHT,
  FOOTER_HEIGHT,
  MAIN_MARGIN,
  NEEDS_TESTCLUSTER_WARNING
} from "./Layout";

export function useHeaderHeight() {
  const [testClusterHidden, setTestClusterHidden] = useSessionStorage({
    key: "testClusterHidden",
    defaultValue: false
  });

  const HEADER_HEIGHT =
    NEEDS_TESTCLUSTER_WARNING && !testClusterHidden
      ? BASE_HEADER_HEIGHT + CLUSTER_ROW_HEIGHT
      : BASE_HEADER_HEIGHT;

  const LAYOUT_MAIN_CONTENT_MIN_HEIGHT = `calc(100vh - ${HEADER_HEIGHT}px - ${FOOTER_HEIGHT}px - (2 * ${MAIN_MARGIN}px))`;
  const hideTestClusterWarning = () => {
    setTestClusterHidden(true);
  };
  return {
    HEADER_HEIGHT,
    LAYOUT_MAIN_CONTENT_MIN_HEIGHT,
    hideTestClusterWarning,
    testClusterHidden
  };
}
